import api from './api';
import { showLoginModal } from '../reducers/loginModal';
import { sendError } from './errorTracking';
import store from '../store';

const verifyUser = (options = {}, callback) => {
  api.get('/subscriptions/verify', { params: options }).then((response) => {
    if(callback){
      callback(response);
    }
    else {
      if(response.data && response.data.success){
        store.dispatch(showLoginModal(response.data.user));
      }
    }
  }).catch((e) => {
    sendError('ERROR: /subscriptions/verify', { message: e.message });
  });
}

export default verifyUser;
